import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dateFormat: null,
};

const slice = createSlice({
  name: "customizationData",
  initialState,
  reducers: {
    setDateFormat: (state, action) => {
      state.dateFormat = action.payload;
    },

    resetDateFormat: () => initialState,
  },
});


export const { setDateFormat, resetDateFormat } = slice.actions;


export const selectDateFormat = (state) => state.customizationData.dateFormat;
export const selectIsDateFormatLoaded = (state) =>
  state.customizationData.dateFormat !== null;


export const customizationDataSlice = slice.reducer;

export default slice.reducer;
